import React from "react";
import ReactECharts from "echarts-for-react";
import "./Index.scss";

function ApexChart({
  chartHeading,
  series = [],
  labels = [],
  colors = ["#4CB944", "#FF5733", "#FFD700", "#58bdff"],
}) {
  // Ensure seriesData is valid and contains numbers
  const validSeriesData = Array.isArray(series)
    ? series.map((val) => Number(val) || 0)
    : [];

  // Pie chart options
  const options = {
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        return `${params.name}: <b>${params.value?.toFixed(2)}</b> (${params.percent}%)`;
      },
    },
    legend: {
      bottom: "0%",
      left: "center",
    },
    series: [
      {
        type: "pie",
        radius: "50%",
        data: labels.map((label, index) => ({
          name: label,
          value: validSeriesData[index] || 0,
        })),
        color: colors,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <div className="stagestats">
      <div className="stagestats_wrapper">
        <h3 className="chart_title">{chartHeading}</h3>
        <div className="chart_wrapper">
          <div className="chartBox">
            <ReactECharts
              option={options}
              style={{ width: "100%", height: 280 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApexChart;
